import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicosPage = lazy(() => import('../pages/servicos/page'));
const SobreNosPage = lazy(() => import('../pages/sobre-nos/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/servicos',
    element: <ServicosPage />,
  },
  {
    path: '/sobre-nos',
    element: <SobreNosPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;